import React from 'react';
import PropTypes from 'prop-types';
import TeamMember from './team_member';

import { reorderableList } from 'helpers/react_dnd/reorderable_list';

function TeamMembersList({
  teamId, teamMembers, onDeleteTeamMember, onEditTeamMember, onReorderTeamMembers, onReorderSave
}) {
  if (!teamMembers || teamMembers.length == 0) return null;

  return (
    <div className="team-members-list">
      {teamMembers.map((teamMember, index) => {
        return (
          <TeamMember
            deleteTeamMember={onDeleteTeamMember}
            editTeamMember={onEditTeamMember}
            index={index}
            key={teamMember.id}
            teamId={teamId}
            teamMember={teamMember}
            onReorder={onReorderTeamMembers}
            onReorderSave={onReorderSave}
          />
        );
      })}
    </div>
  );
}

TeamMembersList.propTypes = {
  teamId: PropTypes.number.isRequired,
  teamMembers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })),
  onDeleteTeamMember: PropTypes.func.isRequired,
  onEditTeamMember: PropTypes.func.isRequired,
  onReorderSave: PropTypes.func.isRequired,
  onReorderTeamMembers: PropTypes.func.isRequired
};

export default reorderableList(TeamMembersList);
